import { useCallback, useMemo } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import {
  useChallengeRewardsNewTypesQuery,
  useChallengeRewardsQuery,
} from '../GraphQL/ChallengeRewards.generated';

export const useChallengeRewards = () => {
  const shouldUseNewRewardsTypes = useFeatureFlag(
    'CELS-487-short-new-reward-types-enabled',
  );

  // ─── Queries ─────────────────────────────────────────────────────────

  const [legacyChallengeRewardsResponse, fetchLegacyChallengeRewards] =
    useChallengeRewardsQuery({
      requestPolicy: 'network-only',
      pause: true,
    });
  const [challengeRewardsNewTypesResponse, fetchChallengeRewardsNewTypes] =
    useChallengeRewardsNewTypesQuery({
      requestPolicy: 'network-only',
      pause: true,
    });

  // ─── Helpers ─────────────────────────────────────────────────────────

  const fetchChallengeRewards = useCallback(() => {
    if (shouldUseNewRewardsTypes) {
      fetchChallengeRewardsNewTypes();

      return;
    }

    fetchLegacyChallengeRewards();
  }, [
    fetchChallengeRewardsNewTypes,
    fetchLegacyChallengeRewards,
    shouldUseNewRewardsTypes,
  ]);

  // ─────────────────────────────────────────────────────────────────────

  const challengeRewardsResponse = shouldUseNewRewardsTypes
    ? challengeRewardsNewTypesResponse
    : legacyChallengeRewardsResponse;
  const challengeRewards = challengeRewardsResponse.data?.challengeRewards;
  const isFetchingChallengeRewards = challengeRewardsResponse.fetching;
  const challengeRewardsError = challengeRewardsResponse.error;

  return useMemo(
    () => ({
      challengeRewards,
      isFetchingChallengeRewards,
      challengeRewardsError,
      fetchChallengeRewards,
    }),
    [
      challengeRewards,
      challengeRewardsError,
      fetchChallengeRewards,
      isFetchingChallengeRewards,
    ],
  );
};
